import * as Session from './session';
import * as Alerts from './alerts';
import * as Entities from './entities';
import * as Settings from './settings';
import * as General from './general';
import * as AiScriber from './aiScriber';
import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { RouterState } from 'connected-react-router';

export interface ApplicationState {
    router: RouterState,
    settings: Settings.State,
    session: Session.State,
    alerts: Alerts.State,
    entities: Entities.State,
    general: General.State,
    aiScriber: AiScriber.State,
}

export const reducers = {
    settings: Settings.reducer,
    session: Session.reducer,
    alerts: Alerts.reducer,
    entities: Entities.reducer,
    general: General.reducer,
    aiScriber: AiScriber.reducer,
};

export const reconsilors = (state: ApplicationState): ApplicationState => ({
    settings: Settings.reconsilor(state.settings),
    session: Session.reconsilor(state.session),
    alerts: Alerts.reconsilor(state.alerts),
    entities: Entities.reconsilor(state.entities),
    general: General.reconsilor(state.general),
    aiScriber: AiScriber.reconsilor(state.aiScriber),
    router: undefined as unknown as RouterState,
});

// Type helpers
export type AppThunkAction<R> = ThunkAction<R, ApplicationState, {}, AnyAction>;
export type AppThunkDispatch = ThunkDispatch<ApplicationState, {}, AnyAction>;